export const UPDATE_ACCOUNT_DETAILS_START = 'UPDATE_ACCOUNT_DETAILS_START';
export const UPDATE_ACCOUNT_DETAILS_SUCCESS = 'UPDATE_ACCOUNT_DETAILS_SUCCESS'
export const UPDATE_ACCOUNT_DETAILS_END = 'UPDATE_ACCOUNT_DETAILS_END';

export const GET_ACCOUNT_DETAILS_START = 'GET_ACCOUNT_DETAILS_START';
export const GET_ACCOUNT_DETAILS_SUCCESS = 'GET_ACCOUNT_DETAILS_SUCCESS';
export const GET_ACCOUNT_DETAILS_FAIL = 'GET_ACCOUNT_DETAILS_FAIL';

